import { connect } from "react-redux";
import { Company } from "./company";
import { bindActionCreators } from "redux";
import { fetchCompany } from "../../../store/thunks/company";
import { resetCompany } from "../../../store/actions/company-actions";

const mapStateToProps = (state) => {
  return {
    company: state.companyState.entity.company,
    status: state.companyState.meta.status,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCompany: bindActionCreators(fetchCompany, dispatch),
    resetCompany: () => dispatch(resetCompany()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Company);
